import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "Util/getCustomColor";

type Props = {
  numberIsInvalid?: boolean;
};

const styles = (props: Props) =>
  makeStyles(() => ({
    label: {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "24px",
      color: getBrandCustom("darkPrimaryColor", colors.brandBlue500),
      marginBottom: "4px",
    },
    info: {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
      textAlign: "center",
      color: "#9CA6AF",
      margin: "0 10px",
    },
    formControl: {
      height: "23px",
      margin: "0 10px",
    },
    containerContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "24px",
    },
    input: {
      height: "23px",
      "& input": {
        padding: "0 0 0 3px",
        display: "flex",
        textAlign: "center",
      },
      "& fieldset": {
        borderColor: "transparent !important",
      },
      "& .MuiOutlinedInput-root": {
        padding: 0,
      },
      "& .MuiInputAdornment-positionEnd": {
        marginLeft: "3px",
        minWidth: 0,
        paddingRight: "10px",
      },
    },
    icon: {
      fontSize: "20px",
    },
    mainDiv: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      border: props?.numberIsInvalid ? "1px solid #F04438" : "1px solid #C4C4C4",
      justifyContent: "space-between",
      padding: "7px",
      borderRadius: "8px",
    },
    iconButton: {
      padding: 0,
    },
    iconError: {
      marginRight: "5px",
      fontSize: "16px",
    },
    formHelper: {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "24px",
      color: "#D92D20",
      alignItems: "center",
      display: "flex",
      margin: 0,
    },
    required: {
      color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
    },
  }));

export default styles;
